import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import {
  TextWidth,
  TextWidthExtended,
  ContentWidth,
} from '@ta-interaktiv/react-disco-grid'

const ImageModule: FC<{
  src: string
  alt: string
  legend: string
  credits: string
}> = ({ src, alt, legend, credits }): ReactElement => {
  return (
    <Container>
      <TextWidthExtended>
        <Image src={src} alt={alt} />
      </TextWidthExtended>
      <TextWidth>
        <figcaption>
          <Legend>{legend}</Legend>
          <Credits>{credits}</Credits>
        </figcaption>
      </TextWidth>
    </Container>
  )
}
const Container = styled.figure`
  -webkit-font-smoothing: auto;
  margin: 0;
`

const Image = styled.img`
  width: 100%;
  vertical-align: bottom;
`

const Legend = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.5rem;
  line-height: 2.1rem;
  padding-top: 1.5rem;
`

const Credits = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.2rem;
  line-height: 1.8rem;
  color: #7d7d7d;
  padding-top: 0.3rem;
  text-transform: uppercase;
`

export default ImageModule
